import { useCallback } from 'react';
export const useOnMouseDown = ({ onDelete, option, setValue, }) => {
    const onMouseDown = useCallback((event) => {
        event.stopPropagation();
        event.preventDefault();
        if (option && onDelete)
            onDelete(option);
    }, [option, onDelete]);
    return onMouseDown;
};
